import { render, staticRenderFns } from "./PgaTextField.vue?vue&type=template&id=0919ac6e&"
import script from "./PgaTextField.vue?vue&type=script&lang=ts&"
export * from "./PgaTextField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0919ac6e')) {
      api.createRecord('0919ac6e', component.options)
    } else {
      api.reload('0919ac6e', component.options)
    }
    module.hot.accept("./PgaTextField.vue?vue&type=template&id=0919ac6e&", function () {
      api.rerender('0919ac6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inputs/PgaTextField.vue"
export default component.exports